var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNohoModraRgb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1243 43.02H37.9747L26.339 28.3298V43.02H21.348V21.6898H27.1511L37.2534 34.7581V21.6898H42.1243V43.0192V43.02Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.012 32.3557C56.012 25.8065 60.9434 21.3303 67.3476 21.3303C73.7518 21.3303 78.6529 25.8065 78.6529 32.3557C78.6529 38.905 73.7215 43.3812 67.3476 43.3812C60.9736 43.3812 56.012 38.8748 56.012 32.3557ZM73.4508 32.3557C73.4508 28.7808 71.1053 25.8963 67.3476 25.8963C63.5898 25.8963 61.2141 28.7506 61.2141 32.3557C61.2141 35.9609 63.5889 38.8151 67.3476 38.8151C71.1062 38.8151 73.4508 35.9609 73.4508 32.3557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.012 67.9062C56.012 61.357 60.9434 56.8807 67.3476 56.8807C73.7518 56.8807 78.6529 61.357 78.6529 67.9062C78.6529 74.4555 73.7215 78.9317 67.3476 78.9317C60.9736 78.9317 56.012 74.4252 56.012 67.9062ZM73.4508 67.9062C73.4508 64.3313 71.1053 61.4468 67.3476 61.4468C63.5898 61.4468 61.2141 64.3011 61.2141 67.9062C61.2141 71.5114 63.5889 74.3656 67.3476 74.3656C71.1062 74.3656 73.4508 71.5114 73.4508 67.9062Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0121 70.1296H26.4584V78.5714H21.3471V57.2411H26.4584V65.6232H37.0121V57.2411H42.1234V78.5714H37.0121V70.1296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNohoModraRgb3);
export default __webpack_public_path__ + "static/media/NOHO-modra_RGB 3.2f191884ac78c1873a045f663be42b8a.svg";
export { ForwardRef as ReactComponent };